module.exports = __webpack_public_path__ + "../../static/img/new-year.242e02f0.png";